import styled from 'styled-components';

export const PatientEdition = styled.div`
`

export const InputParagraphDiv = styled.div`
`

export const InvitePatientsModalDiv = styled.div`
`